import React from 'react';

export const IconClusterWhite = ({ ...args }) => {
  return (
    <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg" {...args}>
      <path
        d="M43.75 33.3333V16.6666C43.7492 15.9359 43.5564 15.2183 43.1907 14.5857C42.825 13.9531 42.2995 13.4278 41.6667 13.0625L27.0833 4.72913C26.4499 4.36342 25.7314 4.1709 25 4.1709C24.2686 4.1709 23.5501 4.36342 22.9167 4.72913L8.33333 13.0625C7.70055 13.4278 7.17496 13.9531 6.80929 14.5857C6.44363 15.2183 6.25075 15.9359 6.25 16.6666V33.3333C6.25075 34.064 6.44363 34.7816 6.80929 35.4142C7.17496 36.0468 7.70055 36.5721 8.33333 36.9375L22.9167 45.2708C23.5501 45.6365 24.2686 45.829 25 45.829C25.7314 45.829 26.4499 45.6365 27.0833 45.2708L41.6667 36.9375C42.2995 36.5721 42.825 36.0468 43.1907 35.4142C43.5564 34.7816 43.7492 34.064 43.75 33.3333Z"
        stroke="white"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.625 8.77087L25 14.1875L34.375 8.77087"
        stroke="white"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.625 41.2292V30.4167L6.25 25"
        stroke="white"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M43.75 25L34.375 30.4167V41.2292"
        stroke="white"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.8125 14.5L25 25.0208L43.1875 14.5"
        stroke="white"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M25 46V25" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};
